import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import AnimatedBackgroundContainer from "./AnimatedBackgroundContainer";
import Config from "../config/Config";
import WaterContainer from "@/containers/WaterContainer";
import SpineAnimationBackgroundContainer from "@/containers/SpineAnimationBackgroundContainer";
import RipplesContainer from "@/containers/RipplesContainer";
import LineAnimatedBackgroundContainer from "@/containers/LineAnimatedBackgroundContainer";
import AnimatiedBackgroundContainer from "@/containers/AnimatiedBackgroundContainer";
import {Signals} from "@/Imports";
import Facade from "@/Facade";
import PlaneConfig from "@/config/PlaneConfig";
import TweenMax, {TweenLite} from "gsap";

export default class GameBackgroundContainer extends BaseContainer {


  constructor(data = null) {
    super(data)

    this.DEBUG = false // To observe the tween that is uses options below
    this.shipStartPosition = () => ({x: -3100, y: -190})
    this.shipEndPosition = 920 // It's will be negative then
    this.shipDelayToHide = 3.5
    this.shipEaseToHide = 'none'

    this.init(data)
  }

  init(data) {

    this.speed = 10
    this.isHorisontal = false
    this.arr = this.DEBUG ? [] : PlaneConfig.land
    Signals.stopFly.add(this.stop, this)
    Signals.makeBets.add(this.reset, this)
    Signals.roundStart.add(this.start, this)
    Signals.roundEnd.add(this.stop, this)
    Signals.multiplier.add(this.updateMultiplier, this)

    this.container = new PIXI.Container()
    this.addChild(this.container)

    const sky = new PIXI.Sprite(PIXI.Texture.from('sky2'))
    this.container.addChild(sky)
    sky.width = 1500
    sky.height = 840
    sky.position.set(0, -220)

    const waterContainer = new WaterContainer()
    waterContainer.position.set(0, 400)

    const shadowFilter = new PIXI.filters.ColorMatrixFilter()
    shadowFilter.brightness(0.6, false)

    const blurFilter = new PIXI.filters.BlurFilter()
    blurFilter.blur = 0.41 //X = 30

    const cloud = new LineAnimatedBackgroundContainer(['cloudBig1', 'cloudBig2', 'cloudBig3', 'cloudBig4', 'cloudBig5', 'cloudBig6', 'cloudBig7'], {
      speed: -1.5,
      sc: 0.8,
      delta: 0,
      coordinateArea: {start: {x: -100, y: -50}, finish: {x: 1300, y: 400}}
    })

    const cloud2 = new LineAnimatedBackgroundContainer(['cloudBig1', 'cloudBig2', 'cloudBig3', 'cloudBig4', 'cloudBig5', 'cloudBig6', 'cloudBig7'], {
      speed: -1,
      sc: 0.8,
      delta: 40,
      coordinateArea: {start: {x: -100, y: -100}, finish: {x: 1300, y: 700}}
    })
    const cloudSmall = new LineAnimatedBackgroundContainer(['cloudSmallHorizon1', 'cloudSmalHorizon2', 'cloudSmalHorizon3', 'cloudSmalHorizon4', 'cloudSmalHorizon5', 'cloudSmalHorizon6', 'cloudSmalHorizon7'], {
      speed: -0.3,
      sc: 0.8,
      delta: 10,
      coordinateArea: {start: {x: -100, y: 200}, finish: {x: 1300, y: 400}}
    })
    const cloudSmall2 = new LineAnimatedBackgroundContainer(['cloudSmalHorizon6', 'cloudSmalHorizon7', 'cloudSmalHorizon8', 'cloudSmalHorizon5'], {
      speed: -0.2,
      sc: 0.8,
      delta: 10,
      coordinateArea: {start: {x: -100, y: 200}, finish: {x: 1300, y: 400}}
    })
    const hill = new LineAnimatedBackgroundContainer(['hillBrown1', 'hillBrown2', 'hillGreen3', 'hillGreen4', 'hillGreen5'], {
      speed: 0,
      sc: 1.5,
      delta: 0,
      coordinateArea: {start: {x: 1000, y: 460}, finish: {x: 1300, y: 460}, delete: {x: -100, y: 460}}
    })

    const shipFar = new LineAnimatedBackgroundContainer(['shipBig', 'shipOil', 'shipSmall1', 'shipSmall2', 'sub'], {
      speed: 1.5,
      sc: 0.4,
      delta: 600,
      //   addImage:{name:'waveMiddle'},
      coordinateArea: {start: {x: 1100, y: 460}, finish: {x: 1300, y: 470}, delete: {x: -100, y: 460}},
    })

    const ship = new LineAnimatedBackgroundContainer(['shipOil', 'shipSmall1', 'shipSmall2', 'sub'], {
      name: 'ship',
      speed: 3,
      sc: 0.8,
      delta: 600,
      // mask: ['cloudSmallHorizon1', 'cloudSmallHorizon1', 'cloudSmallHorizon1', 'shipSmall2Mask'],
      coordinateArea: {start: {x: 1800, y: 490}, finish: {x: 1300, y: 550}, delete: {x: -100, y: 460}}
    })

    this.aircraftСarrier = new PIXI.Sprite(PIXI.Texture.from('shipBig'))
    this.aircraftСarrier.scale.set(2)

    this.container.addChild(cloud)
    this.container.addChild(cloud2)
    this.container.addChild(hill)

    this.container.addChild(waterContainer)
    this.container.addChild(cloudSmall)
    this.container.addChild(cloudSmall2)
    this.container.addChild(shipFar)
    this.container.addChild(ship)
    this.container.addChild(this.aircraftСarrier)

    this.reset()
  }

  reset() {
    const {x, y} = this.shipStartPosition()
    this.aircraftСarrier.position.set(x, y)
    this.container.visible = true
    this.stop()
  }

  updateMultiplier(multiplier) {
    this.currentFar = multiplier
    this.isHorisontal = this.currentFar >= PlaneConfig.farStartMove
  }

  start() {
    this.isHorisontal = false
    this.a = Math.round(Facade.model.deltaTime * 60)

    if (!this.DEBUG && (Facade.model.deltaTime < 0 || this.a >= 151)) {
      this.a = 151
      const o = this.arr[this.arr.length - 1]
      this.aircraftСarrier.x = o.x
      this.container.visible = true
      return
    }

    const {x, y} = this.shipStartPosition()
    this.aircraftСarrier.position.set(x, y)

    // this.delayTween = TweenLite.delayedCall(3, ()=>{
    Signals.tick.add(this.update, this)
    // })

    if (this.DEBUG) {
      this.arr.length = 0
      TweenMax.to(this.aircraftСarrier, this.shipDelayToHide, {
        x: `-=${this.shipEndPosition}`, ease: this.shipEaseToHide, onComplete: () => {
          console.log('::: this.arr', this.arr)
        }
      })
    }
    this.container.visible = true
  }

  stop() {
    Signals.tick.remove(this.update, this)
  }

  update() {
    if (!this.isHorisontal) {
      return
    }

    if (this.DEBUG) {
      const a = {
        x: Number(this.aircraftСarrier.x.toFixed(2)),
      }

      const ar = this.arr
      const l = this.arr.length

      if (ar[l - 1]?.x !== a.x)
        this.arr.push(a)
    }

    if (!this.DEBUG) {
      const o = this.arr[this.a]
      if (!o) console.log("ERROR", this.a, o)
      this.aircraftСarrier.x = o.x
      this.a++
      if (this.a === this.arr.length) {
        this.a = this.arr.length - 1
        this.stop()
      }
    }
  }
}
